// extracted by mini-css-extract-plugin
export default {"main__comingText":"main_main__comingText__gN8gL","main":"main_main__p0fKA"};